import { useRef } from "react"; // Xóa useState thừa nếu không dùng, giữ lại useRef

// Thêm innerRef và onScroll vào props
const DraggableContainer = ({ children, className, innerRef, onScroll }) => {
  // Sử dụng ref nội bộ nếu không có ref từ ngoài truyền vào
  const internalRef = useRef(null);
  const scrollContainerRef = innerRef || internalRef;

  // Logic Drag giữ nguyên, chỉ thay đổi biến ref đang dùng
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);
  const dragMoved = useRef(false);

  const handleMouseDown = (e) => {
    if (!scrollContainerRef.current) return;
    isDragging.current = true;
    dragMoved.current = false;
    startX.current = e.pageX - scrollContainerRef.current.offsetLeft;
    scrollLeft.current = scrollContainerRef.current.scrollLeft;
    scrollContainerRef.current.style.cursor = "grabbing";
  };

  const handleMouseLeaveOrUp = () => {
    if (!scrollContainerRef.current) return;
    isDragging.current = false;
    scrollContainerRef.current.style.cursor = "grab";
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current || !scrollContainerRef.current) return;
    e.preventDefault();
    dragMoved.current = true;
    const x = e.pageX - scrollContainerRef.current.offsetLeft;
    const walk = (x - startX.current) * 1.5;
    scrollContainerRef.current.scrollLeft = scrollLeft.current - walk;
  };

  const handleClickCapture = (e) => {
    if (dragMoved.current) {
      e.stopPropagation();
      e.preventDefault();
    }
  };

  return (
    <div
      className={className}
      ref={scrollContainerRef}
      style={{ cursor: "grab" }}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeaveOrUp}
      onMouseUp={handleMouseLeaveOrUp}
      onMouseMove={handleMouseMove}
      onClickCapture={handleClickCapture}
      onScroll={onScroll} // <--- QUAN TRỌNG: Phải truyền onScroll vào đây
    >
      {children}
    </div>
  );
};

export default DraggableContainer;
